export function criteria(
  state = {
    criteria: [],
    valuePatterns: [],
  },
  action
) {
  switch (action.type) {
    case 'GET_ALL_CRITERIA_START':
      return {
        ...state,
        criteria: [],
      };

    case 'GET_ALL_CRITERIA_DONE':
      return {
        ...state,
        criteria: action.criteria,
      };
    case 'GET_CURRENT_TICKET_START':
      return {
        ...state,
        criteria: [],
      };

    case 'GET_CURRENT_TICKET_DONE':
      return {
        ...state,
        criteria: action.currentTicket.criteria,
      };

    case 'GET_VALUE_PATTERNS_START':
      return state;

    case 'GET_VALUE_PATTERNS_DONE':
      return {
        ...state,
        valuePatterns: action.valuePatterns,
      };
    case 'ADD_CRITERIA_START':
      return state;

    case 'ADD_CRITERIA_DONE':
      return {
        ...state,
        criteria: state.criteria.map(({ criteria, ...restOfObject }) => {
          return {
            criteria: criteria.map(({ criteria, id, ...restOfObject }) => {
              if (id == action.addedCriteria.parentId) {
                return {
                  criteria: [...criteria, action.addedCriteria],
                  ...restOfObject,
                  id,
                };
              } else {
                return {
                  criteria: criteria,
                  ...restOfObject,
                  id,
                };
              }
            }),
            ...restOfObject,
          };
        }),
        closePopup: true,
      };

    case 'EDIT_CRITERIA_START':
      return state;

    case 'EDIT_CRITERIA_DONE':
      return {
        ...state,
        criteria: state.criteria.map(({ criteria, ...restOfObject }) => {
          return {
            criteria: criteria.map(({ criteria, id, ...restOfObject }) => {
              return {
                criteria: criteria.map(element => {
                  if (element.id === action.editedCriteria.id) {
                    return action.editedCriteria;
                  }
                  return element;
                }),
                ...restOfObject,
                id,
              };
            }),
            ...restOfObject,
          };
        }),
        closePopup: true,
      };

    case 'DELETE_CRITERIA_START':
      return state;

    case 'DELETE_CRITERIA_DONE':
      return {
        ...state,
        criteria: state.criteria.map(({ criteria, ...restOfObject }) => {
          return {
            criteria: criteria.map(({ criteria, ...restOfObject }) => {
              return {
                criteria: criteria.filter(
                  tertiaryCriteria =>
                    tertiaryCriteria.id !== action.deletedCriteria
                ),
                ...restOfObject,
              };
            }),
            ...restOfObject,
          };
        }),
        closePopup: true,
      };

    default:
      return state;
  }
}
